// extracted by mini-css-extract-plugin
export default {"r0List":"r0List_QSedK","leftBorder":"leftBorder_jAdcL","checkBack":"checkBack_b3MXN","clickLeft":"clickLeft_sVaRq"};